import React, { useState, useEffect, useRef, useCallback } from "react";
import UpdateQty from "./UpdateQty";
import EditService from "./EditService";
import AddService from "./AddService";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import PriceCalculator from "@heartinz/gst_india_product_price_calculator";
import InvoiceTemp from "./InvoiceTemp";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import Messages from "../../../constants/Messages";
import { useLocation, useNavigate } from "react-router";
import DateConverter from "@heartinz/date_and_time_processor";
import AddServices from "../service/AddService";
import EditServices from "../service/EditService";
import { usePermission } from "../../../context/PermissionContext";
import EditCutomer from "../customer/EditCustomer";
import CustomerModal from "../sale/CustomerModal";
import AddCustomer from "../customer/AddCustomer";
import { useAuth } from "../../../context/AuthProvider";
import { useContextApi } from "../../../context/ContextApi";
import useKeyboardTableNavigation from "../../../constants/useKeyboardTableNavigation";
import SearchInput from "../../../constants/SearchInput";
import { AddIcon, ArrowBackIcon, CalendarIcon, CheckIcon, DeleteIcon, EditIcon } from "../../../constants/Icons";

const EditEstimate = ({ onDone, isActive }) => {
  const customerSuggestionsRef = useRef(null);
  const hasFetched = useRef(false);
  const location = useLocation();
  const [errors, setErrors] = useState({});
  const {
    customerSearchTerm,
    customerSuggestions,
    setCustomerSearchTerm,
    isCustomerData,
    setCustomerData,
    handleCustomerSearch,
    setCustomerSuggestions,
  } = useContextApi();
  const { item, navigatelist } = location?.state || {};
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  // Totals
  const [numberSuggest, setNumberSuggest] = useState([]);
  const [totalRes, setTotals] = useState(0);
  // Modals & loading
  const [btnLoading, setBtnLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [data, setEstimateData] = useState(null);
  const [isEstimateModalOpen, setEstimateModelOpen] = useState(false);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [isEditServiceModalOpen, setEditServiceModalOpen] = useState(false);
  const [isServiceData, setServiceData] = useState(false);
  const [isServiceModalOpen, setServiceModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);
  const [isCustomerModalOpen, setCustomerModalOpen] = useState(false);
  const [truncated, setTruncated] = useState({});
  const contentRefs = useRef([]);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { updateSettings } = useAuth();
  const {
    permission,
    hasPermission,
    customerGroups,
    storeSettings,
    blockedPermissions,
    globelPopupOpen,
  } = usePermission();
  const { handleSuggestEstimate, estimateSuggest, setEstimateSuggest } =
    useContextApi();
  // const [currentDate, setCurrentDate] = useState(new Date());

  // const [estimate, setEstimation] = useState([]);
  const [viewEstimate, setViewEstimate] = useState([]);
  const navigate = useNavigate();
  // const [estimateSuggest, setEstimateSuggest] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const suggestionRefs = useRef([]);
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [addGroupload, setAddGroupLoad] = useState(false);
  const [addNewGroupOpen, setNewGroupOpen] = useState(false);
  const [newGroupName, setNewGroupName] = useState(null);
  const [groupName, setGroupName] = useState(customerGroups);

  const calculateTotal = useCallback(() => {
    const totalMrPrice =
      Number.isInteger(viewEstimate?.totalMrp) && viewEstimate?.totalMrp > 0
        ? viewEstimate?.totalMrp
        : 0;

    const totalSale =
      Number.isInteger(viewEstimate?.totalSalePrice) &&
      viewEstimate?.totalSalePrice > 0
        ? viewEstimate?.totalSalePrice
        : 0;

    const totalBase =
      Number.isInteger(viewEstimate?.totalBasePrice) &&
      viewEstimate?.totalBasePrice > 0
        ? viewEstimate?.totalBasePrice
        : 0;

    const totalTax =
      Number.isInteger(viewEstimate?.totalTaxAmount) &&
      viewEstimate?.totalTaxAmount > 0
        ? viewEstimate?.totalTaxAmount
        : 0;

    const totalRes = PriceCalculator.getGrandTotal(
      totalMrPrice,
      totalSale,
      totalBase,
      totalTax,
    );
    setTotals(totalRes);
  }, [viewEstimate]);

  const openUpdateQuantityModal = (item, index) => {
    if (
      hasPermission("ESTIMATE", "ESTIMATE:updateItem") ||
      permission === undefined
    ) {
      setSelectedItem({ item, index });
      setShowModal(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const closeUpdateQuantityModal = () => {
    // handleListEstimate();
    setShowModal(false);
  };

  const handleClose = () => {
    setEstimateModelOpen(false);
    setEstimateData(null);
    // navigate("/listestimation");
  };

  const handleDone = () => {
    setEstimateModelOpen(false);
    setEstimateData(null);
    onDone?.();
    navigate(navigatelist || "/dashboard");
  };

  const handleNewGroupClose = () => {
    setNewGroupOpen(false);
  };

  const handleNewGroupOpen = () => {
    setNewGroupOpen(true);
  };
  const handleCustomerGroupAdd = async (groupName, method) => {
    setAddGroupLoad(true);
    setNewGroupName(groupName);
    try {
      const data = {
        name: groupName,
      };
      const response = await AxiosInstance.post("module/customer/groups", data);
      const results = response.data.results;
      //  setGroupName(results);
      setGroupName((prev) => [
        { ...results },
        ...(Array.isArray(prev) ? prev : []),
      ]);
      updateSettings({
        customerGroups: [
          { ...results },
          ...(Array.isArray(customerGroups) ? customerGroups : []),
        ],
      });
      showAlert("success", "Customer Group Added Successfull");
      setAddGroupLoad(false);
      handleNewGroupClose();
      setNewGroupName(results);
      if (method === "ADD") {
        handleCustomerModalOpen();
      } else {
        setEditModalOpen(true);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setAddGroupLoad(false);
    }
  };

  const handleEdit = (item) => {
    if (
      hasPermission("ESTIMATE", "ESTIMATE:updateItem") ||
      permission === undefined
    ) {
      // const navigatelist="/listestimation";
      navigate(`/editestimate`, { state: { item, navigatelist } });
      setEstimateModelOpen(false);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };
  const handleSaveClick = async () => {
    try {
      // Optional validation
      // if (!selectedCustomer || Object.keys(selectedCustomer).length === 0) {
      //   showAlert("error", Messages.ERROR.CUSTOMER_EMPTY);
      //   return;
      // }

      // const baseData =
      //   viewEstimate?.estimateItems?.length > 0 || viewEstimate?.estimateTo
      //     ? viewEstimate
      //     : item;

      let settingsData = null;
      try {
        // const response = await AxiosInstance.get("module/storesettings");
        settingsData = storeSettings?.paymentSettings || [];
      } catch (err) {
        console.error("Error fetching settings:", err);
        showAlert("error", "Failed to fetch setting data");
      }

      const fullData = {
        ...viewEstimate,
        settings: settingsData,
      };

      setEstimateData(fullData);
      setEstimateModelOpen(true);
    } catch (error) {
      console.error("Error in handleSaveClick:", error);
      showAlert("error", "Something went wrong while saving estimate");
    }
  };

  const handleAdd = async (newData,quanity, onMode) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        hsnsac: newData.hsnsac,
        title: newData.title,
        description: newData.description,
        mrp: newData.mrp,
        saleprice: newData.saleprice,
        taxpercentage: newData.taxpercentage,
        baseprice: newData.baseprice,
        isLock: newData.isLock,
        unitConfig:newData?.unitConfig,
      };
      const response = await AxiosInstance.post(`module/service`, data);
      // setAddModelOpen(false);
      // setServiceData((prev) => [response.data.results, ...prev]);
      // setTotalItems((prev) => prev + 1);
      showAlert("success", "Service Added");
      setBtnLoading(false);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleCustomerModalOpen = () => {
    handleResetCustomer();
    setCustomerModalOpen(true);
  };

  const handleCustomerModalClose = () => {
    setCustomerModalOpen(false);
    setCustomerData(null);
  };

  const handleResetAddCustomer = () => {
    setCustomerModalOpen(false);
    setCustomerData(null);
  };
  const handleResetCustomer = () => {
    setCustomerSuggestions([]);
    setCustomerSearchTerm("");
  };

  const handleCustomerAdd = async (newData) => {
    setIsBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        ...newData,
        shippingAddress: {
          addressline1: newData.shippingaddressline1,
          addressline2: newData.shippingaddressline2,
          district: newData.shippingdistrict,
          city: newData.shippingcity,
          state: newData.shippingstate,
          statecode: newData.shippingstatecode,
          country: newData.shippingcountry,
          pincode: newData.shippingpincode,
        },

        ...(newData.contactPersonname?.trim() ||
        newData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(newData.contactPersonname?.trim() && {
                  name: newData.contactPersonname,
                }),
                ...(newData.contactPersonNumber?.trim() && {
                  number: newData.contactPersonNumber,
                }),
              },
            }
          : {}),
      };
      const response = await AxiosInstance.post(`module/customer`, data);
      showAlert("success", Messages.SUCCESS.CUSTOMER_ADDED);
      const result = response.data.results;
      if (result.name !== newData.name) {
        showAlert(
          "warning",
          `The phone number"${result.phone}" already exists .`,
        );
        // handleCloseModal();
        return true;
      }
      handleResetAddCustomer();
      handleSelectCustomer(response.data.results);
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        // if (errorMessage.includes("ReferenceId already exists")) {
        //     fieldError.referenceid = "Reference ID already exists .";
        // }
        if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    } finally {
      setIsBtnLoading(false);
    }
  };

  const handleUpdte = async (updatedData) => {
    setIsBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        ...updatedData,
        shippingAddress: {
          addressline1: updatedData.shippingaddressline1,
          addressline2: updatedData.shippingaddressline2,
          district: updatedData.shippingdistrict,
          city: updatedData.shippingcity,
          state: updatedData.shippingstate,
          statecode: updatedData.shippingstatecode,
          country: updatedData.shippingcountry,
          pincode: updatedData.shippingpincode,
        },

        // ✅ Contact Person Object
        ...(updatedData.contactPersonname?.trim() ||
        updatedData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(updatedData.contactPersonname?.trim() && {
                  name: updatedData.contactPersonname,
                }),
                ...(updatedData.contactPersonNumber?.trim() && {
                  number: updatedData.contactPersonNumber,
                }),
              },
            }
          : {}),
        customerid: updatedData._id,
      };
      const response = await AxiosInstance.patch(
        `module/customer/${updatedData._id}`,
        data,
      );
      showAlert("success", Messages.SUCCESS.CUSTOMER_UPDATED);
      setCustomerData(response.data.results);
      setSelectedCustomer(response.data.results);
      closeEditModal();
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        // if (errorMessage.includes("ReferenceId already exists")) {
        //     fieldError.referenceid = "Reference ID already exists .";
        // }
        if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    } finally {
      setIsBtnLoading(false);
    }
  };

  const closeEditModal = () => {
    setEditData(null);
    setEditModalOpen(false);
  };

  const openEditModal = (cItem) => {
    if (
      blockedPermissions("CUSTOMER:viewDetails") ||
      permission === undefined
    ) {
      setEditData(cItem);
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleListEstimate = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/estimate/${item?._id}`,
        // {
        //   estimateid: item?._id,
        // }
      );

      setViewEstimate(response?.data?.results);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handleEztimateDelete = async (itemid) => {
    if (
      hasPermission("ESTIMATE", "ESTIMATE:deleteItem") ||
      permission === undefined
    ) {
      try {
        if (!checkNetwork()) return;
        const response = await AxiosInstance.delete(
          `module/estimate/item/${viewEstimate?._id}?itemid=${itemid}`,
          // {
          //   data: {
          //     estimateid: item?._id,
          //     itemid: itemid,
          //   },
          // }
        );
        setViewEstimate(response.data.results);

        // handleListEstimate();
      } catch (error) {
        handleError(error, showAlert);
        return false;
      }
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleSelectCustomer = async (customer) => {
    if (
      hasPermission("ESTIMATE", "ESTIMATE:addOrUpdateCustomer") ||
      permission === undefined
    ) {
      setSelectedCustomer(customer);
      setCustomerSearchTerm("");
      setCustomerSuggestions([]);
      await handleUpdateCustomer(customer);
      await handleListEstimate();
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleAddService = async (citem, qty, cMode) => {
  
    setIsBtnLoading(true);
    if (cMode === "ADD") {
      handleServiceClose();
    } else if (cMode === "EDIT") {
      handleEditServiceClose();
    }
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.patch(
        `module/estimate/${viewEstimate?._id}`,
        {
          // estimateid: item?._id,
          title: citem?.title,
          hsnsac: citem?.hsnsac,
          description: citem?.description,
          mrp: citem?.mrp,
          saleprice: citem?.saleprice,
          soldprice: citem?.saleprice,
          taxpercentage: citem?.taxpercentage,
          baseprice: citem?.baseprice,
          discount: citem?.discount,
          isLock: citem?.isLock,
          quantity: Number(qty),
          ...(citem?.unitConfig && {
          unitLocked:true,
          unitConfig:citem?.unitConfig})
        },
      );
      setBtnLoading(false);
      if (response.data.results) {
        const newItem = response.data.results.estimateItems;
        const result = response.data.results;

        setViewEstimate((prev) => {
          const existingItems = prev.estimateItems || [];

          const updatedItems = existingItems.some(
            (item) => item._id === newItem._id,
          )
            ? existingItems.map((item) =>
                item._id === newItem._id ? newItem : item,
              )
            : [...existingItems, newItem];

          return {
            ...prev,
            estimateItems: updatedItems,
            totalQty: result.totalQty,
            totalMrp: result.totalMrp,
            totalSalePrice: result.totalSalePrice,
            totalSoldPrice: result.totalSoldPrice,
            totalBasePrice: result.totalBasePrice,
            totalDiscount: result.totalDiscount,
            totalTaxAmount: result.totalTaxAmount,
            grandTotal: result.grandTotal,
            sgstAmount: result.sgstAmount,
            cgstAmount: result.cgstAmount,
            igstAmount: result.igstAmount,
            amountInWords: result.amountInWords,
          };
        });

        const newSuggest = {
          _id: newItem._id,
          title: newItem.title,
          hsnsac: newItem.hsnsac,
        };

        setEstimateSuggest((prev) => {
          const exists = prev.some(
            (item) =>
              item.title === newSuggest.title &&
              item.hsnsac === newSuggest.hsnsac,
          );
          return exists ? prev : [...prev, newSuggest];
        });
      }

      // handleListEstimate();
      showAlert("success", Messages.SUCCESS.SERVICE_ADDED);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setIsBtnLoading(false);
    }
  };

  const handleUpdateQty = async (Qty) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.patch(
        `module/estimate/update/${viewEstimate?._id}`,
        {
          // estimateid: viewEstimate?._id ?? item._id,
          itemid: selectedItem?.item?._id,
          quantity: Qty,
        },
      );
      if (response.data.results) {
        const newItem = response.data.results.estimateItems;
        const result = response.data.results;

        setViewEstimate((prev) => {
          const existingItems = prev.estimateItems || [];

          const updatedItems = existingItems.some(
            (item) => item._id === newItem._id,
          )
            ? existingItems.map((item) =>
                item._id === newItem._id ? newItem : item,
              )
            : [...existingItems, newItem];

          return {
            ...prev,
            estimateItems: updatedItems,
            totalQty: result.totalQty,
            totalMrp: result.totalMrp,
            totalSalePrice: result.totalSalePrice,
            totalSoldPrice: result.totalSoldPrice,
            totalBasePrice: result.totalBasePrice,
            totalDiscount: result.totalDiscount,
            totalTaxAmount: result.totalTaxAmount,
            grandTotal: result.grandTotal,
            sgstAmount: result.sgstAmount,
            cgstAmount: result.cgstAmount,
            igstAmount: result.igstAmount,
            amountInWords: result.amountInWords,
          };
        });
      }
      // await handleListEstimate();
      setBtnLoading(false);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleUpdateEstimate = async (citem, qty, cMode,type) => {
    
    setBtnLoading(true);
    if (cMode === "ADD") {
      handleServiceClose();
    } else if (type === "update") {
      handleEditServiceClose();
    }
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.patch(
        `module/estimate/update/${viewEstimate?._id}`,
        {
          // estimateid: viewEstimate?._id ?? item._id,
          itemid: citem?._id,
          title: citem?.title,
          hsnsac: citem?.hsnsac ?? "",
          description: citem?.description,
          quantity: Number(qty),
          mrp: citem?.mrp,
          saleprice: citem?.saleprice,
          soldprice: citem?.saleprice,
          taxpercentage: citem?.taxpercentage,
          baseprice: citem?.baseprice,
          discount: citem?.discount,
          taxamount: citem?.taxamount,
          isLock: citem.isLock,
          ...(citem?.unitConfig && {
          unitLocked:true,
          unitConfig:citem?.unitConfig})
        },
      );
      if (type === "save") {
        showAlert("success", "Estimate Saved!!");
      }
      setBtnLoading(false);
      if (response.data.results) {
        const newItem = response.data.results.estimateItems;
        const result = response.data.results;

        setViewEstimate((prev) => {
          const existingItems = prev.estimateItems || [];
          const updatedItems = existingItems.some(
            (item) => item._id === newItem._id,
          )
            ? existingItems.map((item) =>
                item._id === newItem._id ? newItem : item,
              )
            : [...existingItems, newItem];

          return {
            ...prev,
            estimateItems: updatedItems,
            totalQty: result.totalQty,
            totalMrp: result.totalMrp,
            totalSalePrice: result.totalSalePrice,
            totalSoldPrice: result.totalSoldPrice,
            totalBasePrice: result.totalBasePrice,
            totalDiscount: result.totalDiscount,
            totalTaxAmount: result.totalTaxAmount,
            grandTotal: result.grandTotal,
            sgstAmount: result.sgstAmount,
            cgstAmount: result.cgstAmount,
            igstAmount: result.igstAmount,
            amountInWords: result.amountInWords,
          };
        });

        const newSuggest = {
          _id: newItem._id,
          title: newItem.title,
          hsnsac: newItem.hsnsac,
        };

        setEstimateSuggest((prev) => {
          const exists = prev.some(
            (item) =>
              item.title === newSuggest.title &&
              item.hsnsac === newSuggest.hsnsac,
          );
          return exists ? prev : [...prev, newSuggest];
        });
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleUpdateCustomer = async (customer) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.patch(
        `module/estimate/customer/${viewEstimate?._id}?customerid=${customer?._id}`,
        {
          // estimateid: item?._id,
          customerid: customer?._id,
        },
      );
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  // const handleSuggestEstimate = async () => {
  //   try {
  //     if (!checkNetwork()) return;
  //     const response = await AxiosInstance.get(
  //       `module/service/suggestion/title`
  //     );

  //     setEstimateSuggest(response.data.results || []);
  //     // setShowtitlePopup(true);
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   }
  // };

  const naviListEstimate = () => {
    if (
      hasPermission("ESTIMATE", "ESTIMATE:list") ||
      permission === undefined
    ) {
      onDone?.(); // ✅ close tab
      navigate(navigatelist || "/listestimation"); // ✅ go to list
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const editItem = async (cItem, index) => {
    if (
      hasPermission("ESTIMATE", "ESTIMATE:updateItem") ||
      permission === undefined
    ) {
      setServiceData({
        ...cItem,
        mrp: CurrencyConverter.toCurrency(cItem.mrp, "INR"),
        saleprice: CurrencyConverter.toCurrency(cItem.saleprice, "INR"),
        discount: CurrencyConverter.toCurrency(cItem.discount, "INR"),
        baseprice: CurrencyConverter.toCurrency(cItem.baseprice, "INR"),
        taxamount: CurrencyConverter.toCurrency(cItem.taxamount, "INR"),
        cIndex: index,
      });
      // await handleSuggestEstimate();
      setEditServiceModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleServiceClose = () => {
    setServiceModalOpen(false);
  };
  const handleServiceOpen = async () => {
    if (
      hasPermission("ESTIMATE", "ESTIMATE:addItem") ||
      permission === undefined
    ) {
      // await handleSuggestEstimate();
      setServiceModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleEditServiceClose = () => {
    setEditServiceModalOpen(false);
  };

  // const handleCustomerNumbersuggestion = async () => {
  //   if (!checkNetwork()) return;
  //   try {
  //     const response = await AxiosInstance("module/customer/suggestion/phone");
  //     const result = response.data.results;
  //     setNumberSuggest(result);
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   }
  // };

  const addNewCustomNumber = (phone) => {
    const trimmed = phone?.trim();

    if (!trimmed) return; // ignore empty/whitespace input

    const exists = numberSuggest?.some(
      (s) => s.phone?.toLowerCase() === trimmed?.toLowerCase(),
    );

    if (!exists) {
      setNumberSuggest((prev) => [
        { _id: Date.now().toString(), phone: trimmed },
        ...prev,
      ]);
    }
  };

  const handleOutsideClick = (e) => {
    if (
      customerSuggestionsRef.current &&
      !customerSuggestionsRef.current.contains(e.target) &&
      !isCustomerModalOpen
    ) {
      handleResetCustomer();
    }
  };

  const handleCustomerKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        Math.min(prev + 1, customerSuggestions.length - 1),
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();

      const trimmedSearch = customerSearchTerm.trim();

      if (trimmedSearch === "") {
        handleSaveClick();
        return;
      }

      const noSelection = highlightedIndex === -1;
      const hasExactMatch = customerSuggestions.some((customer) => {
        const nameMatch =
          customer.name.toLowerCase() === trimmedSearch.toLowerCase();
        const phoneMatch = customer.phone === trimmedSearch;
        return nameMatch || phoneMatch;
      });

      if (noSelection && !hasExactMatch) {
        handleCustomerModalOpen();
        return;
      }

      if (highlightedIndex >= 0) {
        const selected = customerSuggestions[highlightedIndex];
        handleSelectCustomer(selected);
        customerSuggestionsRef.current?.focus();
        setShowCustomerDropdown(false);
        setCustomerSearchTerm("");
        setHighlightedIndex(-1);
      }
    }
  };

  useKeyboardTableNavigation({
    searchTerms: customerSearchTerm,
    suggestions: customerSuggestions,
    modals: {
      isCustomerModalOpen,
      isEditModalOpen,
      isEditServiceModalOpen,
      isServiceModalOpen,
      showModal,
      isEstimateModalOpen,
      globelPopupOpen,
    },
    onEnter: editItem,
  });

  useEffect(() => {
    if (highlightedIndex >= 0 && suggestionRefs.current[highlightedIndex]) {
      suggestionRefs.current[highlightedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [highlightedIndex]);

  useEffect(() => {
    const updated = {};
    contentRefs.current.forEach((el, i) => {
      if (el) {
        const isTruncated = el.scrollHeight > el.clientHeight;
        updated[i] = isTruncated;
      }
    });
    setTruncated(updated);
  }, [viewEstimate]);

  useEffect(() => {
    calculateTotal();
  }, [calculateTotal]);

  // useEffect(() => {
  //   //  if(estimate?._id)
  //   if (hasFetched.current) return;
  //   hasFetched.current = true;
  //   handleSuggestEstimate();
  //   handleListEstimate();
  //   handleCustomerNumbersuggestion();
  // }, []);
  useEffect(() => {
    if (!item?._id) return;

    // 🔁 RESET EVERYTHING that depends on estimate
    hasFetched.current = false;
    setViewEstimate(null);
    setSelectedCustomer(null);
    setTotals(0);

    // 🔄 FETCH NEW DATA
    handleSuggestEstimate();
    handleListEstimate();
    // handleCustomerNumbersuggestion();

    hasFetched.current = true;
  }, [item?._id]);

  useEffect(() => {
    if (viewEstimate?.estimateToId) {
      setSelectedCustomer(viewEstimate?.estimateToId);
    }
  }, [viewEstimate]);

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <>
      <div>
        <div className="page-wrapper">
          <div className="page-content">
            <div className="page-breadcrumb align-items-center mb-3">
              <div className="ms-auto">
                <button
                  type="button"
                  onClick={naviListEstimate}
                  className="btn btn-primary mt-2 mt-lg-0"
                >
                  <ArrowBackIcon/> List Estimate
                </button>
              </div>
            </div>
            <div className="row py-0">
              <div className="col-lg-9">
                <div className="card">
                  <div className="card-body mt-3 py-0 ">
                    <div className="responsive-container justify-content-between">
                      <div
                        className="breadcrumb-title pe-3"
                        style={{ fontSize: "15px" }}
                      >
                        Edit Estimate -:{" "}
                        <span className="badge bg-label-deep-purple rounded-pill">
                          {viewEstimate?.estimateNo}
                        </span>
                      </div>

                      <div className="mb-0">
                        <div className="input-group w-200">
                          <button className="input-group-text">
                            <CalendarIcon/>
                          </button>
                          <input
                            type="text"
                            disabled
                            className="form-control createdon"
                            value={
                              viewEstimate?.estimateDate &&
                              DateConverter.ISOToDisplayFormat(
                                viewEstimate?.estimateDate,
                                "Asia/Kolkata",
                              )?.date
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body px-0">
                    <div className="table-responsive mt-0 modal-dialog-scrollable">
                      <div
                        style={{
                          maxHeight: "400px",
                          overflowY: "auto",
                        }}
                      >
                        <table
                          className="table  align-middle mb-0"
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                          }}
                        >
                          <thead
                            className="table-light"
                            style={{
                              position: "sticky",
                              top: 0,
                              zIndex: 1,
                              backgroundColor: "#dee2e6",
                            }}
                          >
                            <tr>
                              <th className="text-center">S.No</th>
                              <th style={{ width: "70%" }}>Description</th>
                              <th className="text-center w-10">Qty</th>
                              <th className="text-center">Total</th>
                              <th className="text-center">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {viewEstimate?.estimateItems?.map((item, index) => (
                              <tr
                                key={index}
                                className="position-relative  cursor-poInter hover-row"
                                onClick={() => editItem(item, index)}
                                data-item={JSON.stringify(item)}
                              >
                                <td className="text-center">{index + 1}</td>
                                <td className="text-truncate-description">
                                  <div
                                    ref={(el) =>
                                      (contentRefs.current[index] = el)
                                    }
                                    style={{
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      display: "-webkit-box",
                                      WebkitLineClamp: 4,
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {item?.title
                                      ? `${item?.title} - ${item?.description}`
                                      : "-"}
                                  </div>
                                  {truncated[index] && (
                                    <span
                                      style={{
                                        color: "blue",
                                        cursor: "pointer",
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        editItem(item, index);
                                      }}
                                    >
                                      ...View More
                                    </span>
                                  )}
                                  <div className="text-muted small mt-1">
                                    <strong>MRP:</strong> ₹
                                    {CurrencyConverter.toCurrency(
                                      item?.mrp || 0,
                                      "INR",
                                    )}
                                  </div>
                                  <div className="text-muted small mt-1">
                                    <strong>Discount:</strong> ₹{" "}
                                    {CurrencyConverter.toCurrency(
                                      item?.discount || 0,
                                      "INR",
                                    )}
                                  </div>
                                  <div className="text-muted small mt-1">
                                    <strong>Rate:</strong> ₹
                                    {CurrencyConverter.toCurrency(
                                      item?.saleprice || 0,
                                      "INR",
                                    )}
                                  </div>
                                </td>
                                <td className="text-center">
                                  <input
                                    type="text"
                                    value={item?.quantity}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openUpdateQuantityModal(item, index);
                                    }}
                                    readOnly
                                    className="form-control text-center"
                                  />
                                </td>
                                <td className="text-center">
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    item?.lineTotalSalePrice || 0,
                                    "INR",
                                  )}
                                </td>
                                <td className="text-center">
                                  <div className="order-actions opacity-0 opacity-md-100">
                                    <button
                                      type="button"
                                      className="btn-label-primary shadow-none me-2"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        editItem(item, index);
                                      }}
                                    >
                                      <EditIcon/>
                                    </button>
                                    <button
                                      type="button"
                                      className="btn-label-danger shadow-none me-2"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleEztimateDelete(item?._id);
                                      }}
                                    >
                                      <DeleteIcon/>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="ms-0 ms-lg-auto p-3 pt-0">
                    <button
                      type="button"
                      onClick={() => handleServiceOpen()}
                      className="btn btn-primary mt-2 mt-lg-0"
                    >
                      <AddIcon/> Add Service
                    </button>
                  </div>
                </div>
                {/* <div className="d-block">
                  <button type="button">
                    <i className="bx bx-check"></i> Save
                  </button>
                </div> */}
              </div>

              <div className="col-lg-3">
                <div className="card mb-6">
                  <div className="card-body">
                    {/* <div className=" position-relative">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          name="search"
                          autoComplete="off"
                          ref={customerSuggestionsRef}
                          value={customerSearchTerm}
                          onChange={(e) => {
                            handleCustomerSearch(e.target.value);
                            setShowCustomerDropdown(true);
                            setHighlightedIndex(-1);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "ArrowDown") {
                              e.preventDefault();
                              setHighlightedIndex((prev) =>
                                Math.min(
                                  prev + 1,
                                  customerSuggestions.length - 1
                                )
                              );
                            } else if (e.key === "ArrowUp") {
                              e.preventDefault();
                              setHighlightedIndex((prev) =>
                                Math.max(prev - 1, 0)
                              );
                            } else if (e.key === "Enter") {
                              e.preventDefault();
                              if (highlightedIndex >= 0) {
                                const selected =
                                  customerSuggestions[highlightedIndex];
                                handleSelectCustomer(selected);
                              }
                            }
                          }}
                          onFocus={() => {
                            if (customerSuggestions.length > 0) {
                              setShowCustomerDropdown(true);
                            }
                          }}
                          placeholder="Search customer by name, phone, email, referenceID..."
                        />
                        <button className="input-group-text">
                          <i className="bx bx-search"></i>
                        </button>
                      </div>

                      {customerSearchTerm &&
                        customerSuggestions?.length === 0 && (
                          <ul className="suggestions-list">
                            <li className="suggestion-item text-muted">
                              No customers data was found
                            </li>
                          </ul>
                        )}

                      {showCustomerDropdown &&
                        customerSuggestions?.length > 0 && (
                          <ul className="suggestions-list">
                            {customerSuggestions?.map((customer, index) => (
                              <li
                                ref={(el) =>
                                  (suggestionRefs.current[index] = el)
                                }
                                key={customer?._id}
                                onClick={() => handleSelectCustomer(customer)}
                                className={`suggestion-item ${
                                  highlightedIndex === index
                                    ? "highlighted"
                                    : ""
                                }`}
                              >
                                {customer?.name} -{" "}
                                <span className="badge badge-primary badge bg-label-blue rounded-pill">
                                  {customer?.phone}
                                </span>
                                {customer?.referenceid && (
                                  <>
                                    <small>-</small>{" "}
                                    <span className="badge badge-info badge bg-label-secondary rounded-pill">
                                      {customer?.referenceid}
                                    </span>
                                  </>
                                )}
                              </li>
                            ))}
                          </ul>
                        )}
                    </div> */}
                    <div className="ms-auto position-relative">
                      <SearchInput
                        searchRef={customerSuggestionsRef}
                        value={customerSearchTerm}
                        onChange={(e) => {
                          handleCustomerSearch(e.target.value);
                          setShowCustomerDropdown(true);
                          setHighlightedIndex(-1);
                        }}
                        onFocus={() => {
                          if (customerSuggestions.length > 0) {
                            setShowCustomerDropdown(true);
                          }
                        }}
                        onSearch={
                          customerSearchTerm.trim()
                            ? () =>
                                handleCustomerModalOpen(
                                  customerSearchTerm.trim(),
                                )
                            : null
                        }
                        placeholder="Search customer by name, phone, email, referenceID..."
                        onKeyDown={handleCustomerKeyDown}
                      />
                      {customerSearchTerm &&
                        customerSuggestions.length === 0 && (
                          <ul className="suggestions-list">
                            <li className="suggestion-item text-muted">
                              No customers data was found
                            </li>
                          </ul>
                        )}
                      {showCustomerDropdown &&
                        customerSuggestions?.length > 0 && (
                          <ul className="suggestions-list">
                            {customerSuggestions?.map((customer, index) => (
                              <li
                                ref={(el) =>
                                  (suggestionRefs.current[index] = el)
                                }
                                key={customer._id}
                                onClick={() => handleSelectCustomer(customer)}
                                className={`suggestion-item ${
                                  highlightedIndex === index
                                    ? "highlighted"
                                    : ""
                                }`}
                              >
                                {customer?.name} -{" "}
                                <span className="badge badge-primary badge bg-label-blue rounded-pill">
                                  {customer?.phone}
                                </span>
                                {customer?.referenceid && (
                                  <>
                                    <small>-</small>{" "}
                                    <span className="badge badge-info badge bg-label-secondary rounded-pill">
                                      {customer?.referenceid}
                                    </span>
                                  </>
                                )}
                              </li>
                            ))}
                          </ul>
                        )}
                    </div>
                    <div className="col-lg-12 mt-1">
                      <div className="card shadow-none border-blue mb-0">
                        <div className="card-header bg-label-infoss p-2 d-flex justify-content-between align-items-center">
                          <div className="mb-0">Customer Info </div>
                          {selectedCustomer && (
                            <div>
                              <button
                                type="button"
                                className="bg-label-infoss rounded shadow-none border-0"
                                onClick={() => openEditModal(selectedCustomer)}
                              >
                                <EditIcon/>
                              </button>
                            </div>
                          )}
                        </div>
                        <div className="card-body px-2 py-0">
                          {selectedCustomer ? (
                            <>
                              <p className="my-1 fs-13">
                                Name :{" "}
                                <span className="fw-600 fs-14">
                                  {selectedCustomer?.name}
                                </span>
                              </p>
                              <p className="my-1 fs-13">
                                Phone :{" "}
                                <span className="fw-600 fs-14">
                                  {selectedCustomer?.phone}{" "}
                                </span>
                              </p>
                              {selectedCustomer?.referenceid && (
                                <p className="my-1 fs-13">
                                  Reference ID :{" "}
                                  <span className="fw-600 fs-14">
                                    {selectedCustomer?.referenceid}
                                  </span>
                                </p>
                              )}
                            </>
                          ) : (
                            <p className="my-2 text-muted">
                              No customers has been selected
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card mb-6">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <p className="mb-0" style={{ fontSize: "13px" }}>
                        Total MRP :
                      </p>
                      <h6 className="mb-0 fs-20" style={{ fontSize: "13px" }}>
                        {CurrencyConverter.toCurrency(
                          totalRes?.totalmrp || 0,
                          "INR",
                        )}
                      </h6>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <p className="mb-0" style={{ fontSize: "13px" }}>
                        Total Discount :
                      </p>
                      <h6 className="mb-0 fs-20" style={{ fontSize: "13px" }}>
                        {CurrencyConverter.toCurrency(
                          totalRes?.totaldiscount || 0,
                          "INR",
                        )}
                      </h6>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                      <p className="mb-0" style={{ fontSize: "13px" }}>
                        Total Amount :
                      </p>
                      <h6 className="mb-0 fs-20" style={{ fontSize: "13px" }}>
                        {CurrencyConverter.toCurrency(
                          totalRes?.totalsaleprice || 0,
                          "INR",
                        )}
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="card mb-6">
                  <div className="card-body">
                    {/* <button
                      type="button"
                      className="btn btn-outline-secondary text-left w-100 mb-2"
                    >
                      <i className="bx bx-x"></i>cancel
                    </button> */}
                    <button
                      type="button"
                      className="btn btn-primary text-right w-100 "
                      onClick={handleSaveClick}
                    >
                      <CheckIcon/>Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isEstimateModalOpen && (
        <InvoiceTemp
          data={data}
          onClose={handleClose}
          onEdit={handleEdit}
          onDone={handleDone}
        />
      )}

      {showModal && selectedItem && (
        <UpdateQty
          data={selectedItem.item}
          onEstimateUpdate={handleUpdateQty}
          btnLoading={btnLoading}
          // updateQuantity={updateQuantity}
          onClose={closeUpdateQuantityModal}
        />
      )}

      {isServiceModalOpen && (
        <AddServices
          isActive={isActive}
          onClose={handleServiceClose}
          onAdd={handleAddService}
          isBtnLoading={isBtnLoading}
          estimateSuggest={estimateSuggest}
          onAddservice={handleAdd}
          AddServiceBtn={true}
        />
      )}

      {isEditServiceModalOpen && (
        <EditServices
          isActive={isActive}
          onClose={handleEditServiceClose}
          onUpdate={handleUpdateEstimate}
          editData={isServiceData}
          isBtnLoading={isBtnLoading}
          estimateSuggest={estimateSuggest}
          isSaveBtn={true}
          onAdd={handleAdd}
        />
      )}

      {isEditModalOpen && (
        <EditCutomer
          editData={isEditData}
          onClose={closeEditModal}
          onEdit={handleUpdte}
          isBtnLoading={isBtnLoading}
          groupName={groupName}
          groupId={selectedCustomer?.groupid}
          onNewGroupsIn={handleCustomerGroupAdd}
          resetAll={true}
          newGroup={newGroupName}
          error={errors}
          setErrors={setErrors}
        />
      )}

      {/* {isCustomerModalOpen && (
        <CustomerModal
          onClose={handleCustomerModalClose}
          onConfirm={handleCustomerAdd}
          onData={isCustomerData}
          isBtnLoading={isBtnLoading}
          groupName={groupName}
          onNewGroupsIn={handleCustomerGroupAdd}
          newGroup={newGroupName}
        />
      )} */}

      <AddCustomer
        isOpen={isCustomerModalOpen}
        onClose={handleCustomerModalClose}
        onData={isCustomerData}
        onAdd={handleCustomerAdd}
        isBtnLoading={isBtnLoading}
        groupName={groupName}
        onNewGroupsIn={handleCustomerGroupAdd}
        newGroup={newGroupName}
        resetAll={true}
        error={errors}
        setErrors={setErrors}
        numberSuggest={numberSuggest}
        addNewCustomNumber={addNewCustomNumber}
      />
    </>
  );
};

export default EditEstimate;
